import React from "react";

const Spinner = () => {
  return (
    <div className="flex justify-center">
      <div className="animate-spin rounded-full h-14 w-14 border-t-4 border-blue-500 border-solid"></div>
    </div>
  );
};

export default Spinner;
